export const loadScript = (script) => {
  return new Promise((resolve, reject) => {
    const id = script.replace(/\/|\./g, '-')
    if (document.getElementById(id)) {
      return resolve('Already loaded.')
    }
    var scriptElem = document.createElement('script')
    scriptElem.id = id
    scriptElem.src = script
    scriptElem.onload = resolve
    scriptElem.onerror = reject
    document.getElementsByTagName('head')[0].appendChild(scriptElem)
  })
}

export const loadScriptsInOrder = (scripts) => {
  if (!scripts || scripts.length <= 0) { return Promise.resolve() }
  const script = scripts.shift()
  return loadScript(script).then(() => {
    if (scripts.length > 0) {
      return loadScriptsInOrder(scripts)
    }

    return Promise.resolve()
  })
}



// WEBPACK FOOTER //
// ./src/services/loader.js